const _throttle = require('lodash.throttle');

let resizeListenerAdded = false;

function initializeDynamicColumns() {
    // Support both v4 data-dynamic-column and v5 data-faq-column selectors
    const dynamicColumnPanels = document.querySelectorAll('.faq-panel.grid,.people-panel.grid,.accordion-panel.grid');

    dynamicColumnPanels.forEach(dynamicColumnPanel => {
        const dynamicColumns = {
            1: dynamicColumnPanel.querySelector('[data-dynamic-column="1"],[data-faq-column="1"]'),
            2: dynamicColumnPanel.querySelector('[data-dynamic-column="2"],[data-faq-column="2"]'),
            3: dynamicColumnPanel.querySelector('[data-dynamic-column="3"],[data-faq-column="3"]'),
            4: dynamicColumnPanel.querySelector('[data-dynamic-column="4"],[data-faq-column="4"]')
        };

        if (!dynamicColumns[1]) return;

        function distributeDynamicCards() {
            const dynamicCards = Array.from(dynamicColumnPanel.querySelectorAll('[data-dynamic-card-index],[data-faq-card-index]'));

            // Sort cards by index
            dynamicCards.sort((a, b) => {
                const aIndex = parseInt(a.dataset.dynamicCardIndex ?? a.dataset.faqCardIndex ?? 0);
                const bIndex = parseInt(b.dataset.dynamicCardIndex ?? b.dataset.faqCardIndex ?? 0);
                return aIndex - bIndex;
            });

            // Distribute cards based on media queries
            const windowWidth = window.innerWidth;

            if (windowWidth < 640) {
                dynamicCards.forEach(card => {
                    dynamicColumns[1].appendChild(card);
                });
            } else if (windowWidth >= 640 && windowWidth < 1024) {
                dynamicCards.forEach((card, index) => {
                    const columnNumber = (index % 2) + 1;
                    dynamicColumns[columnNumber].appendChild(card);
                });
            } else if (windowWidth >= 1024 && windowWidth < 1280) {
                dynamicCards.forEach((card, index) => {
                    const columnNumber = (index % 3) + 1;
                    dynamicColumns[columnNumber].appendChild(card);
                });
            } else {
                dynamicCards.forEach((card, index) => {
                    const columnNumber = (index % 4) + 1;
                    dynamicColumns[columnNumber].appendChild(card);
                });
            }
        }

        const throttledDistribute = _throttle(distributeDynamicCards, 200);

        // Add resize listener only once
        if (!resizeListenerAdded) {
            window.addEventListener('resize', () => {
                const windowWidth = window.innerWidth;

                if ((windowWidth < 640 && window.prevWidth >= 640) ||
                    (windowWidth >= 640 && windowWidth < 1024 && (window.prevWidth < 640 || window.prevWidth >= 1024)) ||
                    (windowWidth >= 1024 && windowWidth < 1280 && (window.prevWidth < 1024 || window.prevWidth >= 1280)) ||
                    (windowWidth >= 1280 && window.prevWidth < 1280)) {
                    throttledDistribute();
                }
                window.prevWidth = windowWidth;
            });
            resizeListenerAdded = true;
        }

        // Initial distribution
        distributeDynamicCards();
    });
}

// Run on both DOMContentLoaded and window load
document.addEventListener('DOMContentLoaded', initializeDynamicColumns);
window.addEventListener('load', initializeDynamicColumns);
